
    <span class="text-secondary text-center">
        {{ license.completionPercentage}}%
    </span>
    <div class="progress prog-bar text-center position-relative" role="progressbar" aria-label="" [attr.aria-valuenow]="50"
        aria-valuemin="0" aria-valuemax="100">
        <span class="position-absolute top-50 start-50 translate-middle w-100 text-center">
            {{license.modulesCompleted + '/' + license.totalModules}}
        </span>
        <div class="progress-colored-bar" [style.width]="license.completionPercentage + '%'"></div>
    </div>